
export type RollingIndexState =
    "Pending"
    | "Running"
    | "Done";